export default {
  clientType: state => state.clientType,
  clientAuditData: state => state.clientAuditData,
  clientAuditDetail: state => state.clientAuditDetail,
  auditContacts: state => state.auditContacts,
};
